/**
 * Global namespace for `Dropdown` types / classes.
 */
const dropdownMenuClasses = ["dropdown", "dropup", "dropstart", "dropend"];
export default dropdownMenuClasses;
